import { createSelector } from 'reselect';
import BalanceOnHandTransactionsHistoryColumns from '../../containers/BalanceOnHandTransactionsHistoryColumns';
import TableDefinitions from '../../../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.BALANCE_ON_HAND_TRANSACTIONS_HISTORY.isLoading;
export const getData = TableDefinitions.BALANCE_ON_HAND_TRANSACTIONS_HISTORY.getDataFunction();
export const getColumns = createSelector(getData, BalanceOnHandTransactionsHistoryColumns);
